import React from "react";
import "./Pricing.css";

function Pricing() {
  return (
    <div className="home-page">
      <h1>Welcome to ClearEar2U</h1>
      <p>This is the home page content.</p>
    </div>
  );
}

export default Pricing;